import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Table, Pagination, Modal } from 'antd';
import { apiUrls } from '../apiUrls.js';
import { toast } from 'react-toastify';
import AmountFormat from "../components/AmountFormat.js";
import InputNumberFormat from "../components/InputNumberFormat.js";

const { Option } = Select;
const baseURL = apiUrls.baseURL;

const EndOfProgram = React.memo(({ data, onRefresh, isShowOtherProgramCosts, isShowAssistantLeaderAmount }) => {

    const [isShowModalVisible, setIsShowModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState({});
    const [informationEndOfProgram, setInformationEndOfProgram] = useState({});
    const [dropDownAssistants, setDropDownAssistants] = useState([]);

    const getAssistantLeaderAmounts = (assistantLeaderIds, currentAmounts) => {
        return (assistantLeaderIds || []).map((id) => ({
            id,
            amount: currentAmounts?.find((item) => item.id === id)?.amount || ''
        }));
    };

    const onAssistantLeadersChange = (assistantLeaderIds) => {
        setModel({
            ...model,
            assistantLeaderIds,
            assistantLeaderAmounts: getAssistantLeaderAmounts(assistantLeaderIds, model.assistantLeaderAmounts)
        });
    };

    const onAssistantLeaderAmountChange = (id, amount) => {
        setModel({
            ...model,
            assistantLeaderAmounts: getAssistantLeaderAmounts(model.assistantLeaderIds, model.assistantLeaderAmounts)
                .map((item) => item.id === id ? { ...item, amount } : item)
        });
    };

    const getAssistantLeaderAmount = (id) => {
        return model.assistantLeaderAmounts?.find((item) => item.id === id)?.amount;
    };

    const selectedAssistantLeaders = dropDownAssistants
        .filter((item) => model.assistantLeaderIds?.includes(item.id));

    useEffect(() => {
        setModel({ ...model, programId: data.id })
    }, [])

    const submit = async (id) => {

        if (model.assistantLeaderAmounts?.some((item) => item.amount !== 0 &&
            item.amount !== null &&
            item.amount !== undefined &&
            item.amount !== '') &&
            (!model.assistantLeaderIds || model.assistantLeaderIds.length === 0)) {
            return toast.warning("کمک سرپرست انتخاب نشده است ", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        if (model.assistantLeaderIds?.length > 0 &&
            model.assistantLeaderAmounts?.some((item) => item.amount === null || item.amount === undefined || item.amount === '' || item.amount === 0)) {
            return toast.warning("مبلغ دستمزد همه کمک سرپرستان انتخاب شده را وارد کنید", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        const requestModel = {
            ...model,
            assistantLeaderAmounts: getAssistantLeaderAmounts(model.assistantLeaderIds, model.assistantLeaderAmounts)
                .filter((item) => item.amount !== null && item.amount !== undefined && item.amount !== '')
        };

        try {
            setLoading(true);
            const token = localStorage.getItem('damavandclub-token')
            await axios.post(`${apiUrls.baseURL}/program/endofprogram`, requestModel, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            onRefresh();

            toast.success("با موفقیت ثبت شد", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsShowModalVisible(false)
            setModel({ ...model, customeLeaderAmount: null })
            setLoading(false);
        } catch (error) {
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setLoading(false);
            setIsShowModalVisible(false)
        } finally {
            setLoading(false);
            setIsShowModalVisible(false)
        }
    };

    const check = async () => {
        setLoading(true)
        try {
            const token = localStorage.getItem('damavandclub-token')

            const responseAssistant = await axios.get(`${baseURL}/program/GetDropdownAssistantLeaders?id=${data.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var resultAssistant = responseAssistant.data.data;
            setDropDownAssistants(resultAssistant);

            var response = await axios.get(`${apiUrls.baseURL}/program/endofprogram?id=${data.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            setIsShowModalVisible(true);
            setLoading(false)
            var result = response.data.data;
            setInformationEndOfProgram(result);
        } catch (error) {
            setLoading(false)
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
        }
    }

    return (
        <>
            <Button className="end-program-open-button" loading={loading} size='small' onClick={() => { check(); setModel({ ...model, userId: null, amount: null }) }}
                style={{ backgroundColor: 'white', color: 'black', marginTop: 5, width: '100%' }}
                type="primary"><label>ثبت پایان برنامه</label></Button>

            <Modal
                className="end-program-modal"
                width={700}
                centered
                zIndex={1100}
                title={`ثبت پایان برنامه:  ${data.nameFa}`}
                open={isShowModalVisible}
                closable
                destroyOnClose
                okButtonProps={null}
                footer={<div className='row-container end-program-footer'>
                    <Button onClick={() => setIsShowModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loading}
                        onClick={() => submit(data.id)}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>ثبت پابان برنامه</Button>
                </div>}
                onCancel={() => setIsShowModalVisible(false)}
            >
                <div className="end-program-content" dir="rtl">
                    <div className="end-program-summary">
                        <div className="end-program-summary-card"><span>مجموع پرداخت اعضای برنامه</span><strong><AmountFormat amount={informationEndOfProgram.totalPaidAmount} /><small>ریال</small></strong></div>
                        <div className="end-program-summary-card is-highlighted"><span>دستمزد محاسبه‌شده سرپرست</span><strong><AmountFormat amount={informationEndOfProgram.leaderAmount} /><small>ریال</small></strong></div>
                    </div>
                    <section className="end-program-section">
                        <div className="end-program-section-heading"><span className="end-program-section-number">۱</span><div><strong>دستمزد سرپرست</strong><small>در صورت اعمال دستمزد متفاوت، مبلغ را وارد کنید؛ در غیر این صورت خالی بگذارید.</small></div></div>
                        <InputNumberFormat value={model.customeLeaderAmount} placeholder="مبلغ به ریال" onValueChange={(value) => setModel({ ...model, customeLeaderAmount: value })} />
                        <div className="end-program-field-hint">این مبلغ نباید بیشتر یا مساوی مجموع هزینه‌های واریزی برنامه باشد.</div>
                    </section>
                    {isShowAssistantLeaderAmount && dropDownAssistants.length > 0 && (
                        <section className="end-program-section">
                            <div className="end-program-section-heading"><span className="end-program-section-number">۲</span><div><strong>دستمزد کمک‌سرپرستان</strong><small>افرادی را که باید دستمزد دریافت کنند انتخاب کنید و مبلغ هر نفر را بنویسید.</small></div></div>
                            <Select className="end-program-assistant-select" style={{ width: '100%' }} showSearch allowClear mode="multiple" maxTagCount="responsive" placeholder="انتخاب کمک‌سرپرست" notFoundContent="موردی پیدا نشد" optionFilterProp="label" onChange={onAssistantLeadersChange} value={model.assistantLeaderIds}>
                                {dropDownAssistants.map((item) => <Option key={item.id} label={item.displayName} value={item.id}>{item.displayName}</Option>)}
                            </Select>
                            {selectedAssistantLeaders.length > 0 && <div className="end-program-assistant-list">
                                {selectedAssistantLeaders.map((item) => <div key={item.id} className="end-program-assistant-card">
                                    <strong>{item.displayName}</strong>
                                    <InputNumberFormat value={getAssistantLeaderAmount(item.id)} placeholder="مبلغ به ریال" onValueChange={(value) => onAssistantLeaderAmountChange(item.id, value)} />
                                </div>)}
                            </div>}
                        </section>
                    )}
                    <section className="end-program-section">
                        <div className="end-program-section-heading"><span className="end-program-section-number">{isShowAssistantLeaderAmount && dropDownAssistants.length > 0 ? '۳' : '۲'}</span><div><strong>هزینه‌های برنامه</strong><small>موارد بدون هزینه را خالی بگذارید.</small></div></div>
                        <div className="end-program-cost-grid">
                            <div className="end-program-field"><label>هزینه بیمه برنامه</label><InputNumberFormat value={model.insuranceAmount} placeholder="مبلغ به ریال" onValueChange={(value) => setModel({ ...model, insuranceAmount: value })} /></div>
                            {isShowOtherProgramCosts && <div className="end-program-field"><label>سایر هزینه‌ها</label><InputNumberFormat value={model.otherProgramCosts} placeholder="مبلغ به ریال" onValueChange={(value) => setModel({ ...model, otherProgramCosts: value })} /></div>}
                        </div>
                        {isShowOtherProgramCosts && <div className="end-program-field end-program-description-field"><label>توضیحات سایر هزینه‌ها</label><textarea value={model.otherProgramCostsDescription} onChange={(event) => setModel({ ...model, otherProgramCostsDescription: event.target.value })} placeholder="شرح کوتاهی از هزینه‌های ثبت‌شده بنویسید" /></div>}
                    </section>
                </div>
            </Modal>
        </>
    );
});

EndOfProgram.propTypes = {
    data: PropTypes.any,
    onRefresh: PropTypes.any,
    isShowOtherProgramCosts: PropTypes.bool,
    isShowAssistantLeaderAmount: PropTypes.bool
};

EndOfProgram.displayName = 'EndOfProgram';

export default EndOfProgram;
